// @ts-strict-ignore
import React, { useContext } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Separator,
} from '@usealloy/component-library';
import { IsolatedEditorContainer } from 'flow/editor/styles';
import {
  StyledTipCallout,
  StyledAggregationCriteriaContainer,
  StyledAggregationSubEditorLayout,
  StyledAggregationSubEditorRow,
  StyledAggregationSubEditorActions,
} from './styles';
import BaseAggregationsSection from './BaseAggregationsSection';
// import AggregationFiltersSection from './AggregationFiltersSection';
import AggregationNameAndDescription from './AggregationNameAndDescription';
import { AggregationEditorContext } from './context';
import { useAppDispatch } from '~/store/reduxHooks';
import { RuleEditorContext } from '../NodeEditorDrawer/context';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import type { PopulatedThreshold } from 'flow/store/engine/types';
import { INITIAL_AGGREGATION_CONFIG } from './constants';

type AggregationsSubEditorContainerProps = {
  data: { threshold: PopulatedThreshold | null };
};

const AggregationsSubEditorContainer = ({ data }: AggregationsSubEditorContainerProps) => {
  const dispatch = useAppDispatch();
  const { setIsolatedEditingBlock } = useContext(RuleEditorContext);
  const { setSourceData, handleClose, aggregationEditorContainerRef } = useContext(
    AggregationEditorContext,
  );
  const { threshold } = data;

  const handleSave = () => {
    if (!threshold) {
      handleClose();
      return;
    }
    // TODO: Replace temporary defaults -- OAK-1062 provides real aggregation config output.
    if (!threshold.operator) {
      dispatch(updateThreshold.operator(threshold.publicId, 'gt'));
    }
    if (threshold.right.attributeValue === null
        || threshold.right.attributeValue === ''
    ) {
      dispatch(updateThreshold.rightValue(threshold.publicId, 0));
    }
    handleClose();
  };

  const clearAggregationsSubEditorState = () => {
    handleClose();
    setSourceData(INITIAL_AGGREGATION_CONFIG);
    setIsolatedEditingBlock({
      originPublicId: undefined,
      originType: undefined,
      originCaretIndex: undefined,
    });
  };

  return (
    <IsolatedEditorContainer ref={aggregationEditorContainerRef}>
      <StyledAggregationSubEditorLayout>
        <StyledAggregationSubEditorRow>
          <StyledAggregationCriteriaContainer>
            <StyledTipCallout text="Build your custom aggregation by selecting the options below." />
            <BaseAggregationsSection />
            {/* <AggregationFiltersSection /> */}
          </StyledAggregationCriteriaContainer>
          <AggregationNameAndDescription />
        </StyledAggregationSubEditorRow>
        <Separator />
        <StyledAggregationSubEditorActions>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.secondary}
            onClick={clearAggregationsSubEditorState}
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.primary}
            onClick={handleSave}
          >
            Done
          </Button>
        </StyledAggregationSubEditorActions>
      </StyledAggregationSubEditorLayout>
    </IsolatedEditorContainer>
  );
};

export default AggregationsSubEditorContainer;
